import React from 'react';
import PropTypes from 'prop-types';

import utils from './../../lib/utils';

import BookingSoftwares from './../../assets/BookingSoftwares';

import './index.scss';

export default class SoftwareSetupSuccess extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.getTextNumber();

    // Get Bookings Software Info
    this.props.getBookingSoftware();
  }

  render() {
    const bookingSoftware =
      BookingSoftwares[this.props.softwares.selectedSoftware] || {};

    const isSetupComplete =
      this.props.softwares.isVerified && !this.props.softwares.isRequested;

    const onBackClick = () => {
      if (isSetupComplete) {
        this.props.onBackClick();
      } else {
        this.props.onBackClick(2);
      }
    };

    return (
      <div className="mindbody-success">
        <span className="mindbody-success__user">
          Hi{' '}
          {this.props.business.info.FIRST_NAME ||
            this.props.business.info.EMAIL}
        </span>
        {isSetupComplete ? (
          <div>
            <p className="mindbody-success__heading">
              Thanks for authorizing TrueLark to sync with your{' '}
              {bookingSoftware.label || ''} software!
            </p>
            <p className="mindbody-success__phone-text">
              Your TrueLark text-only number is:
            </p>
            <span className="mindbody-success__phone-no">
              {utils.hyphenatePhone(this.props.carriers.phoneNumber)}
            </span>
            <div className="mindbody-success__steps">
              <p className="step">
                Your customers can now text on this number for bookings and
                inquiries! Please advertise this number and print it on your
                busniness cards.
              </p>
              <p className="step">
                You must now setup your business phones to forward any calls
                that you miss to the above text-only number.
              </p>
            </div>
          </div>
        ) : (
          <div>
            <p className="mindbody-success__message">
              We&apos;ll verify that we are able to access your account with
              these details and help you complete your setup. This might take
              upto 2 days. In the interim, feel free to contact TrueLark Support
              (+1-408-582-7010) for any questions you might have.
            </p>
          </div>
        )}
        {isSetupComplete ? (
          <div className="mindbody-success__actions">
            <button
              type="button"
              className="btn btn--secondary btn--lg"
              onClick={onBackClick}
            >
              Go Back
            </button>
            <button
              type="button"
              className="btn btn--primary btn--lg"
              onClick={this.props.onNextClick}
              disabled={!isSetupComplete}
            >
              NEXT
            </button>
          </div>
        ) : (
          <div className="mindbody-success__actions">
            <button
              type="button"
              className="btn btn--primary btn--lg"
              onClick={this.props.onOkClick}
            >
              OK
            </button>
          </div>
        )}
      </div>
    );
  }
}

SoftwareSetupSuccess.defaultProps = {
  onBackClick: () => {},
  onNextClick: () => {},
  onOkClick: () => {},
  getTextNumber: () => {},
  getBookingSoftware: () => {},
};

SoftwareSetupSuccess.propTypes = {
  onBackClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onOkClick: PropTypes.func,
  getTextNumber: PropTypes.func,
  getBookingSoftware: PropTypes.func,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    isVerified: PropTypes.bool,
    isRequested: PropTypes.bool,
  }).isRequired,
  carriers: PropTypes.shape({
    phoneNumber: PropTypes.string,
  }).isRequired,
  business: PropTypes.shape({
    info: {
      FIRST_NAME: PropTypes.string,
      EMAIL: PropTypes.string,
    },
  }).isRequired,
};
